/**
 * @fileOverview This file contains the implementation of the YearCalendarDialog component
 * @version 1.0.0
 * @since 1.0.0
 * @author Miguel Ángel Bermea Rodríguez
 */

//#region  Imports
import '../../scss/Components/MaintenanceAgenda/_yeardialog.scss';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
} from '@mui/material';

import { LocalizationProvider } from '@mui/x-date-pickers-pro/';
import { YearCalendar } from '@mui/x-date-pickers/YearCalendar';
import { AdapterMoment } from '@mui/x-date-pickers-pro/AdapterMoment';
import moment from 'moment';
//#endregion

const YearCalendarDialog = ({ open, close, selectedYear, setSelectedYear }) => {
  /**
   * Set selectedYear to currentYear
   */
  const handleCurrentYear = () => {
    setSelectedYear(moment());
    close();
  };

  return (
    <Dialog open={open} onClose={close}>
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography className="agenda-year-dialog-title">
          Seleccione el año
        </Typography>
        <Button
          variant="contained"
          onClick={handleCurrentYear}
          className="agenda-year-dialog-actual"
        >
          Actual
        </Button>
      </DialogTitle>

      <DialogContent>
        <LocalizationProvider
          dateAdapter={AdapterMoment}
          adapterLocale={moment.locale()}
        >
          <YearCalendar
            value={selectedYear}
            onChange={(newYear) => {
              setSelectedYear(newYear);
              close();
            }}
            label="Year"
          />
        </LocalizationProvider>
      </DialogContent>
    </Dialog>
  );
};

export default YearCalendarDialog;
